import { api } from './api';

export interface IArchiveOccupancy {
  totalArchives: number;
  totalBoxes: number;
  totalCapacity: number;
  totalStoredDocuments: number;
  overallOccupancyRate: number;
  boxes: {
    id: string;
    name: string;
    code: string;
    capacity: number;
    stored: number;
    freeSpace: number;
    occupancyPercentage: number;
  }[];
}

export interface IPhysicalMovementsReport {
  totalMovements: number;
  pendingCount: number;
  overdueCount: number;
  returnedCount: number;
  movements: {
    id: string;
    type: string;
    status: string;
    documentName: string;
    borrowerName: string;
    borrowerDocument?: string;
    responsibleUserName: string;
    departureDate: string;
    expectedReturnDate?: string;
    actualReturnDate?: string;
    isOverdue: boolean;
  }[];
}

export interface ICpadOfficialReport {
  totalTerms: number;
  terms: {
    id: string;
    termNumber: string;
    type: 'eliminacao' | 'permanente';
    title: string;
    committeePresident: string;
    evaluators: string[];
    justification: string;
    legalBasis: string;
    date: string;
    totalDocuments: number;
    documents: {
      id: string;
      name: string;
      documentDate: string;
      classificationCode: string;
      documentTypeName: string;
      legalBasis: string;
    }[];
  }[];
}

export interface ILgpdAuditReport {
  summary: {
    totalSignedDocuments: number;
    totalGovBrSignatures: number;
    totalIcpSignatures: number;
    totalAuditEvents: number;
  };
  recentEvents: {
    id: string;
    action: string;
    userName: string;
    userEmail: string;
    documentName: string;
    createdAt: string;
  }[];
}

export const reportsService = {
  async getArchiveOccupancy(): Promise<IArchiveOccupancy> {
    const response = await api.get('/reports/archive-occupancy');
    return response.data;
  },

  async getPhysicalMovements(params?: { startDate?: string; endDate?: string; status?: string }): Promise<IPhysicalMovementsReport> {
    const response = await api.get('/reports/physical-movements', { params });
    return response.data;
  },

  async getCpadOfficial(termId?: string): Promise<ICpadOfficialReport> {
    const response = await api.get('/reports/cpad-official', { params: { termId } });
    return response.data;
  },

  async getLgpdAudit(params?: { startDate?: string; endDate?: string }): Promise<ILgpdAuditReport> {
    const response = await api.get('/reports/lgpd-audit', { params });
    return response.data;
  },
};
